var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.siteLocationsSrv.selectedLcoation
    ? _c(
        "div",
        { staticClass: "d-flex flex-column overflow-hidden height-100x" },
        [
          _c("div", { staticClass: "grey lighten-3 mb-4 flex-shrink-0" }, [
            _c(
              "div",
              { staticClass: "d-flex align-center results-header" },
              [
                _c(
                  "div",
                  { staticClass: "px-5" },
                  [
                    _c(
                      "v-row",
                      {
                        staticClass: "results-header-h1",
                        staticStyle: { width: "500px" },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "d-flex",
                            attrs: { lg: "12", cols: "6" },
                          },
                          [
                            _c("v-img", {
                              staticClass: "area-search header-img-title",
                              attrs: {
                                height: "20",
                                width: "20",
                                contain: "",
                                src: require("@/assets/icons/equipment-light.png"),
                              },
                            }),
                            _c("h2", { staticClass: "areaTitle" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SiteComponents.EquipmentDetails.Title"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      _vm._l(_vm.locationPath, function (path, index) {
                        return _c(
                          "div",
                          { key: path.id, staticClass: "d-flex" },
                          [
                            path.type === "site" && _vm.diagramViewStyle
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: "/images/plant.png",
                                  },
                                })
                              : _vm._e(),
                            path.type === "site" && !_vm.diagramViewStyle
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: require("@/assets/icons/plant-light.png"),
                                  },
                                })
                              : _vm.diagramViewStyle &&
                                path.type === "location" &&
                                index === _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "20",
                                    width: "22",
                                    contain: "",
                                    src: "/images/equip.png",
                                  },
                                })
                              : !_vm.diagramViewStyle &&
                                path.type === "location" &&
                                index === _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: require("@/assets/icons/equipment-light.png"),
                                  },
                                })
                              : _vm.diagramViewStyle &&
                                path.type === "location" &&
                                index < _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: "/images/area.png",
                                  },
                                })
                              : !_vm.diagramViewStyle &&
                                path.type === "location" &&
                                index < _vm.locationPath.length - 1
                              ? _c("v-img", {
                                  staticClass: "area-search header-img-title",
                                  attrs: {
                                    height: "18",
                                    width: "18",
                                    contain: "",
                                    src: require("@/assets/icons/area-light.png"),
                                  },
                                })
                              : _vm._e(),
                            path.type === "site"
                              ? _c("h4", { staticClass: "header-title-text" }, [
                                  _vm._v(_vm._s(path.title)),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "cursor-pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "goToLocation",
                                          path.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "h4",
                                      { staticClass: "header-title-text" },
                                      [_vm._v(_vm._s(path.title))]
                                    ),
                                  ]
                                ),
                            index !== _vm.locationPath.length - 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "header-title-text next-arrow",
                                    staticStyle: {
                                      color: "white",
                                      padding: "0px 5px",
                                    },
                                  },
                                  [_vm._v(" > ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _c("v-spacer"),
                !_vm.readOnlyFlagValue
                  ? _c(
                      "div",
                      { staticClass: "px-3" },
                      [
                        _c(
                          "base-btn",
                          {
                            staticStyle: {
                              border: "1px solid white !important",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("saveEquipmentDetail")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("Common.Save")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.diagramViewStyle
                  ? _c(
                      "div",
                      { staticClass: "px-3" },
                      [
                        _c(
                          "base-btn",
                          {
                            staticStyle: {
                              padding: "0 !important",
                              border: "none",
                              height: "auto",
                              "min-width": "auto",
                              "background-color": "white !important",
                              "box-shadow": "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("fullPageFormView", true)
                              },
                            },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                height: "16",
                                width: "16",
                                contain: "",
                                src: "/images/enlarge.png",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "base-btn",
                          {
                            staticStyle: {
                              padding: "0 !important",
                              border: "none",
                              height: "auto",
                              "min-width": "auto",
                              "background-color": "white !important",
                              "box-shadow": "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("goToLocation", null)
                              },
                            },
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                height: "36",
                                width: "36",
                                contain: "",
                                src: "/images/minus.png",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm.siteLocationsSrv.locationDetailDataFieldStatuses.length > 0
              ? _c(
                  "div",
                  { staticClass: "warning-box" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "SiteComponents.EquipmentDetails.WarningCountMsg",
                            {
                              count:
                                _vm.siteLocationsSrv
                                  .locationDetailDataFieldStatuses.length,
                            }
                          )
                        ) + " "
                      ),
                    ]),
                    _c(
                      "base-btn",
                      {
                        attrs: { color: "#e17e2c", outlined: "", small: "" },
                        on: { click: _vm.summaryClick },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Common.Details")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.siteLocationsSrv.selectedLcoation.equipmentDetail &&
          _vm.siteLocationsSrv.selectedLcoation.equipmentDetail.id
            ? _c(
                "div",
                {
                  key: "siteLocationsSrv.selectedLcoation.equipmentDetail.id || 0",
                  staticClass:
                    "flex-grow-1 flex-1 overflow-auto d-flex detailed-forms info-tabs-header",
                },
                [
                  _c(
                    "div",
                    { staticClass: "col col-12" },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "my-tabs min-height-100",
                          staticStyle: { "background-color": "white" },
                          attrs: {
                            vertical: _vm.diagramViewStyle ? false : true,
                          },
                        },
                        [
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("General Information")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Parent Area Information")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Warnings")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Equipment Certification")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Tag Management")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Internet of Things")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Digital Twin")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Circuit")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Inspection History")]
                          ),
                          !_vm.diagramViewStyle
                            ? _c(
                                "v-tab",
                                {
                                  attrs: { "active-class": "side-tab-active" },
                                },
                                [_vm._v("Documentation")]
                              )
                            : _vm._e(),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Note")]
                          ),
                          _c(
                            "v-tab",
                            { attrs: { "active-class": "side-tab-active" } },
                            [_vm._v("Equipment Report")]
                          ),
                          !_vm.readOnlyFlagValue && _vm.diagramViewStyle
                            ? _c(
                                "div",
                                {
                                  staticClass: "px-3",
                                  staticStyle: { "margin-left": "auto" },
                                },
                                [
                                  _c(
                                    "base-btn",
                                    {
                                      staticStyle: {
                                        border: "1px solid white !important",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$emit(
                                            "saveEquipmentDetail"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Save")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .equipmentDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled: true,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation.id,
                                                      name: "equipmentID",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EquipmentID.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation,
                                                          "id",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .title,
                                                      name: "areaName",
                                                      disabled: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EquipmentName.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation,
                                                          "title",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      readonly: "",
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value: _vm.locationPath
                                                        .map((loc) => loc.title)
                                                        .join(" > "),
                                                      name: "locationName",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Location.Label"
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Classification",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentEquipmentClassification
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .equipmentClassification,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EquipmentClassification.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "equipmentClassification",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "equipmentFieldEquipmentAssociatedApparatus",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentFieldEquipmentAssociatedApparatus
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .fieldEquipmentAssociatedApparatus,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.FieldEquipmentAssociatedApparatus.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "fieldEquipmentAssociatedApparatus",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .manufacturer,
                                                      name: "equipManufacturer",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Manufacturer.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "manufacturer",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .supplier,
                                                      name: "equipSupplier",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Supplier.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "supplier",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .modelNo,
                                                      name: "equipModelNo",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ModelNo.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "modelNo",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .serialNo,
                                                      name: "equipSerialNo",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.SerialNo.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "serialNo",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "divisionForRiskLevel",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentDivisionForRiskLevel
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .divisionForRiskLevel,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.DivisionForRiskLevel.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "divisionForRiskLevel",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-date-picker", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.InstalledDate.Label"
                                                      ),
                                                      name: "installedDate",
                                                      format: true,
                                                      formatStr: "yyyy-MM-dd",
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .installedDate,
                                                      max: _vm.$helpers.formatDate(
                                                        new Date().toISOString()
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "installedDate",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "text-h5" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SiteComponents.EquipmentDetails.ElectricalPowerInfo"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "powerType",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentPowerType
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .powerType,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.PowerType.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "powerType",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "powerType",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentACDC
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail.ACDC,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ACDC.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "ACDC",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .phasesf,
                                                      name: "phasesf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Phases.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "phasesf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .converterNamef,
                                                      name: "converterName",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ConverterName.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "converterNamef",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .voltageVf,
                                                      name: "voltageVf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.VoltageV.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "voltageVf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .frequencyHzf,
                                                      name: "frequencyHzf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.FrequencyHz.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "frequencyHzf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .minVoltageVf,
                                                      name: "minVoltageVf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MinVoltageV.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "minVoltageVf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .minFrequencyHzf,
                                                      name: "minFrequencyHzf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MinFrequencyHz.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "minFrequencyHzf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .maxVoltageVf,
                                                      name: "maxVoltageVf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MaxVoltageV.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "maxVoltageVf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .maxFrequencyHzf,
                                                      name: "maxFrequencyHzf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MaxFrequencyHz.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "maxFrequencyHzf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      !_vm.siteLocationsSrv.selectedLcoation
                                        .locationId
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-h4 text-center",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SiteComponents.EquipmentDetails.NoParentAreaInfo"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm.siteLocationsSrv.selectedLcoation
                                            .parentLocation
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      name: "areaID",
                                                      disabled: "",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.AreaID.Label"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .locationId,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation,
                                                          "locationId",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.locationId",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      name: "title",
                                                      disabled: "",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.AreaTitle.Label"
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation.title,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation,
                                                          "title",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.title",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "6" } },
                                                    [
                                                      _c("base-text-field", {
                                                        staticStyle: {
                                                          color: "#fdf7e7",
                                                        },
                                                        attrs: {
                                                          name: "lowAmbientTemp",
                                                          disabled: "",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.LowAmbientTemperature.Label"
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .lowAmbientTemp,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "lowAmbientTemp",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.lowAmbientTemp",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "6" } },
                                                    [
                                                      _c("base-text-field", {
                                                        staticStyle: {
                                                          color: "#fdf7e7",
                                                        },
                                                        attrs: {
                                                          name: "highAmbientTemp",
                                                          disabled: "",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.HighAmbientTemperature.Label"
                                                          ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .highAmbientTemp,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "highAmbientTemp",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.highAmbientTemp",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("base-autocomplete", {
                                                        attrs: {
                                                          dense: "",
                                                          outlined: "",
                                                          items:
                                                            _vm
                                                              .adminDataFieldsSrv
                                                              .areaFieldOptions[
                                                              _vm.areaFieldsList
                                                                .areaIpx
                                                            ],
                                                          "item-text": "value",
                                                          "item-value": "id",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.Ipx.Label"
                                                          ),
                                                          "return-object": false,
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .ipx,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "ipx",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.ipx",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.siteLocationsSrv
                                                .selectedLcoation
                                                .parentLocation &&
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.parentLocation
                                                .locationDetail
                                                ? _c(
                                                    "v-col",
                                                    { attrs: { cols: "3" } },
                                                    [
                                                      _c("base-autocomplete", {
                                                        attrs: {
                                                          dense: "",
                                                          outlined: "",
                                                          items:
                                                            _vm
                                                              .adminDataFieldsSrv
                                                              .areaFieldOptions[
                                                              _vm.areaFieldsList
                                                                .areaIpy
                                                            ],
                                                          "item-text": "value",
                                                          "item-value": "id",
                                                          label: _vm.$t(
                                                            "Fields.AreaFields.Ipy.Label"
                                                          ),
                                                          "return-object": false,
                                                          disabled: "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .parentLocation
                                                              .locationDetail
                                                              .ipy,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .siteLocationsSrv
                                                                .selectedLcoation
                                                                .parentLocation
                                                                .locationDetail,
                                                              "ipy",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.ipy",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaGasArea
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.GasArea.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .gasZone,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "gasZone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.gasZone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaGasGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.GasGroup.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .gasGroup,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "gasGroup",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.gasGroup",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaGasTemperatureClass
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.GasTempClass.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .gasTempClass,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "gasTempClass",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.gasTempClass",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaDustArea
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustArea.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustZone,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustZone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustZone",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .areaFieldOptions[
                                                          _vm.areaFieldsList
                                                            .areaDustGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustGroup.Label"
                                                      ),
                                                      "return-object": false,
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustgroup,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustgroup",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustgroup",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      name: "dustCloudIgnitionTemp",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustCloudIgnitionTemperature.Label"
                                                      ),
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustCloudIgnitionTemp,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustCloudIgnitionTemp",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustCloudIgnitionTemp",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation &&
                                      _vm.siteLocationsSrv.selectedLcoation
                                        .parentLocation.locationDetail
                                        ? _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      name: "dustLayerDepth",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustLayerDepth.Label"
                                                      ),
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustLayerDepth,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustLayerDepth",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustLayerDepth",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      name: "dustLayerIgnitionTemp",
                                                      label: _vm.$t(
                                                        "Fields.AreaFields.DustLayerIgnitionTemperature.Label"
                                                      ),
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .parentLocation
                                                          .locationDetail
                                                          .dustLayerIgnitionTemp,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .parentLocation
                                                            .locationDetail,
                                                          "dustLayerIgnitionTemp",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "siteLocationsSrv.selectedLcoation.parentLocation.locationDetail.dustLayerIgnitionTemp",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c("WarningsListComponent", {
                                attrs: {
                                  locationId:
                                    _vm.siteLocationsSrv.selectedLcoation.id,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .equipmentDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Certification Scheme",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentCertificationScheme
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .certificationScheme,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.CertificationScheme.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentCertificationScheme"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentCertificationScheme"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "certificationScheme",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .certificationNumber,
                                                      name: "certificationNumber",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.CertificationNumber.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "certificationNumber",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .suffixf,
                                                      name: "suffixf",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Suffix.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "suffixf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .lowAmbientTemperature,
                                                      name: "equipmentLowAmbientTemp",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.LowAmbientTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentLowAmbientTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentLowAmbientTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "lowAmbientTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .highAmbientTemperature,
                                                      name: "equipmentHighAmbientTemp",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.HighAmbientTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentHighAmbientTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentHighAmbientTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "highAmbientTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .lowServiceTemperature,
                                                      name: "equipmentLowServiceTemp",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.LowServiceTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentLowServiceTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentLowServiceTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "lowServiceTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .highServiceTemperature,
                                                      name: "equipmentHighServiceTemp",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.HighServiceTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentHighServiceTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentHighServiceTemperature"
                                                        ),
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "highServiceTemperature",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentCombinationOptionGas
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .combinationOptionGas,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EquipmentCombinationOptionGas.Label"
                                                      ),
                                                      "return-object": false,
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "combinationOptionGas",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentInspectionFrequency
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .inspectionFrequency,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EquipmentInspectionFrequency.Label"
                                                      ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "inspectionFrequency",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Protection Technique (Gas)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentProtectionTechniqueGas
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .protectionTechniqueGas,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ProtectionTechniqueGas.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueGas"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueGas"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "protectionTechniqueGas",
                                                          $event
                                                        )
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.siteLocationsSrv.selectedLcoation.equipmentDetail.protectionTechniqueEplGas =
                                                          []
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      name: "Protection Technique EPL (Gas)",
                                                      items:
                                                        _vm.adminDataFieldsSrv.getDependentItemsOf(
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentProtectionTechniqueEplGas,
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentProtectionTechniqueGas
                                                        ),
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .protectionTechniqueEplGas,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ProtectionTechniqueEPLGas.Label"
                                                      ),
                                                      clearable: "",
                                                      disabled:
                                                        !_vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .protectionTechniqueGas ||
                                                        _vm.readOnlyFlagValue,
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueEplGas"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueEplGas"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "protectionTechniqueEplGas",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Protection Technique (Dust)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentProtectionTechniqueDust
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .protectionTechniqueDust,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ProtectionTechniqueDust.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueDust"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueDust"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "protectionTechniqueDust",
                                                          $event
                                                        )
                                                      },
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.siteLocationsSrv.selectedLcoation.equipmentDetail.protectionTechniqueEplDust =
                                                          []
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      name: "Protection Technique EPL (Dust)",
                                                      items:
                                                        _vm.adminDataFieldsSrv.getDependentItemsOf(
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentProtectionTechniqueEplDust,
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentProtectionTechniqueDust
                                                        ),
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .protectionTechniqueEplDust,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ProtectionTechniqueEPLDust.Label"
                                                      ),
                                                      clearable: "",
                                                      disabled:
                                                        !_vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .protectionTechniqueDust ||
                                                        _vm.readOnlyFlagValue,
                                                      multiple: true,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueEplDust"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentProtectionTechniqueEplDust"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "protectionTechniqueEplDust",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "EPL (Gas)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentEplGas
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EplGas.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .ePLGas,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentEplGas"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentEplGas"
                                                        ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "ePLGas",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Gas group",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentGasGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.GasGroup.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .gasGroupf,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentGasGroup"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentGasGroup"
                                                        ),
                                                      "return-object": false,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "gasGroupf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "EPL (Dust)",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentEplDust
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.EplDust.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .ePLDust,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentEplDust"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentEplDust"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "ePLDust",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    staticClass: "flex-grow-1",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "Dust Group",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentDustGroup
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      rules: "required",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.DustGroup.Label"
                                                      ),
                                                      clearable: "",
                                                      multiple: false,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .dustGroupf,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentDustGroup"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentDustGroup"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "dustGroupf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      name: "equipmentGasTemperatureClass",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentGasTemperatureClass
                                                        ],
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .gasTemperatureClass,
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.GasTempClass.Label"
                                                      ),
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentGasTemperatureClass"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentGasTemperatureClass"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "gasTemperatureClass",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      dense: "",
                                                      outlined: "",
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .maxSurfaceTempf,
                                                      name: "maximumSurfaceTemperature",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MaxSurfaceTemperature.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentMaxSurfaceTemperature"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentMaxSurfaceTemperature"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "maxSurfaceTempf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentIpx
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail.ipx,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Ipx.Label"
                                                      ),
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentIpx"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentIpx"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "ipx",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-autocomplete", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      dense: "",
                                                      outlined: "",
                                                      items:
                                                        _vm.adminDataFieldsSrv
                                                          .equipmentFieldOptions[
                                                          _vm
                                                            .equipmentFieldsList
                                                            .equipmentIpy
                                                        ],
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail.ipy,
                                                      "item-text": "value",
                                                      "item-value": "id",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.Ipy.Label"
                                                      ),
                                                      multiple: true,
                                                      limit: 2,
                                                      "return-object": false,
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentIpy"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentIpy"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "ipy",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .testDustLayerf,
                                                      name: "maximumSurfaceTemperature",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.TestingDustLayerDepth.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentTestingDustLayerDepth"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentTestingDustLayerDepth"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "testDustLayerf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "3" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticStyle: {
                                                      color: "#fdf7e7",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .maxSurfaceTempWithDustLayerCf,
                                                      name: "maximumSurfaceTemperature",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MaxSurfaceTemperatureWithDustLayer.Label"
                                                      ),
                                                      "error-count":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentMaxSurfaceTempWithDustLayer"
                                                        ).length ?? 1,
                                                      "error-messages":
                                                        _vm.siteLocationsSrv.checkFieldError(
                                                          "equipmentMaxSurfaceTempWithDustLayer"
                                                        ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "maxSurfaceTempWithDustLayerCf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .specialConditionsUsef,
                                                      name: "specialconditionsuse",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.SpecialConditionForUse.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "specialConditionsUsef",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .exComponentInformationf,
                                                      name: "exComponentInformation",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ExComponentInformation.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "exComponentInformationf",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .warningMarkingInformation,
                                                      name: "warningMarkingInformation",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.WarningMarkingInformation.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "warningMarkingInformation",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlagValue,
                                                      value:
                                                        _vm.siteLocationsSrv
                                                          .selectedLcoation
                                                          .equipmentDetail
                                                          .exMarketing,
                                                      name: "equipExMarking",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.ExMarking.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            .equipmentDetail,
                                                          "exMarketing",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "MiscellaneousCertificationComponent",
                                            {
                                              attrs: {
                                                "read-only":
                                                  _vm.readOnlyFlagValue,
                                              },
                                            }
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation.id
                                ? _c("TagManagementComponent", {
                                    key: _vm.siteLocationsSrv.selectedLcoation
                                      .id,
                                    attrs: {
                                      siteLocationId:
                                        _vm.siteLocationsSrv.selectedLcoation
                                          .id,
                                      readOnlyFlagValue: _vm.readOnlyFlagValue,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .equipmentDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c("v-card-text", [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-row",
                                              [
                                                _vm.siteLocationsSrv
                                                  .selectedLcoation.id
                                                  ? _c(
                                                      "sensor-management-component",
                                                      {
                                                        key: _vm
                                                          .siteLocationsSrv
                                                          .selectedLcoation.id,
                                                        attrs: {
                                                          siteLocationId:
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .id,
                                                          readOnlyFlagValue:
                                                            _vm.readOnlyFlagValue,
                                                        },
                                                      }
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _vm.siteLocationsSrv.selectedLcoation
                                .equipmentDetail
                                ? _c(
                                    "v-card",
                                    { attrs: { flat: "" } },
                                    [
                                      _c("DigitalTwinCanvasComponent", {
                                        key: _vm.siteLocationsSrv
                                          .selectedLcoation.id,
                                        attrs: {
                                          siteLocationId:
                                            _vm.siteLocationsSrv
                                              .selectedLcoation.id,
                                          readOnlyFlagValue:
                                            _vm.readOnlyFlagValue,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-sheet",
                                                {
                                                  staticClass: "mx-auto",
                                                  attrs: { "max-width": "300" },
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "SiteComponents.EquipmentDetails.TotalWireEntries"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm.siteLocationsSrv
                                                              .selectedLcoation
                                                              .wiringCables
                                                              ?.length
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-slide-group",
                                                    {
                                                      attrs: {
                                                        "slider-color":
                                                          "#1b3054",
                                                        "show-arrows": "",
                                                        centered: "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "prev",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      text: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.prev()
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-chevron-left"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                          {
                                                            key: "next",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      text: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.next()
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-chevron-right"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1796914642
                                                      ),
                                                      model: {
                                                        value: _vm.tab,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.tab = $$v
                                                        },
                                                        expression: "tab",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.siteLocationsSrv
                                                        .selectedLcoation
                                                        .wiringCables,
                                                      function (entry) {
                                                        return _c(
                                                          "v-slide-item",
                                                          {
                                                            key: entry.id,
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    active,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          staticClass:
                                                                            "tab-cable",
                                                                          attrs:
                                                                            {
                                                                              "input-value":
                                                                                active,
                                                                              "active-class":
                                                                                "tab-cable-active",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.setActive(
                                                                                  entry.id
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                entry?.name ??
                                                                                  "Core 1"
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          !_vm.readOnlyFlagValue
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticClass: "text-right",
                                                  staticStyle: {
                                                    "justify-content": "right",
                                                    position: "absolute",
                                                    right: "5px",
                                                  },
                                                  attrs: { cols: "2" },
                                                },
                                                [
                                                  _c(
                                                    "base-btn",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "12px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.setNew()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Common.AddWire"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      !_vm.showAddNew
                                        ? _c(
                                            "v-tabs-items",
                                            {
                                              model: {
                                                value: _vm.tab,
                                                callback: function ($$v) {
                                                  _vm.tab = $$v
                                                },
                                                expression: "tab",
                                              },
                                            },
                                            _vm._l(
                                              _vm.siteLocationsSrv
                                                .selectedLcoation.wiringCables,
                                              function (entry, index) {
                                                return _c(
                                                  "v-tab-item",
                                                  { key: entry.id },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            _c(
                                                              "v-row",
                                                              [
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          value:
                                                                            entry.id,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CableID.Label"
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "id",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          value:
                                                                            entry.name,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CableName.Label"
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "name",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "flex-grow-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          name: "wiringCableEntryType",
                                                                          items:
                                                                            _vm
                                                                              .adminDataFieldsSrv
                                                                              .equipmentFieldOptions[
                                                                              _vm
                                                                                .equipmentFieldsList
                                                                                .equipmentWiringCableEntryType
                                                                            ],
                                                                          value:
                                                                            entry.cableType,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CableEntryType.Label"
                                                                            ),
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableType",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.Manufacturer.Label"
                                                                            ),
                                                                          value:
                                                                            entry.manufacturer,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "manufacturer",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.ModelNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.modelNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "modelNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.SerialNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.serialNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "serialNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CertificationNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.certificationNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "certificationNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "flex-grow-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          name: "wiringProtectionType",
                                                                          items:
                                                                            _vm
                                                                              .adminDataFieldsSrv
                                                                              .equipmentFieldOptions[
                                                                              _vm
                                                                                .equipmentFieldsList
                                                                                .equipmentWiringCableProtectionType
                                                                            ],
                                                                          value:
                                                                            entry.protectionType,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.ProtectionType.Label"
                                                                            ),
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                          "error-count":
                                                                            _vm.siteLocationsSrv.checkFieldError(
                                                                              "equipmentWiringCableProtectionType",
                                                                              entry.id
                                                                            )
                                                                              .length ??
                                                                            1,
                                                                          "error-messages":
                                                                            _vm.siteLocationsSrv.checkFieldError(
                                                                              "equipmentWiringCableProtectionType",
                                                                              entry.id
                                                                            ),
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "protectionType",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CableModelNo.Label"
                                                                            ),
                                                                          value:
                                                                            entry.cableModelNo,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableModelNo",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        staticClass:
                                                                          "flex-grow-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          name: "equipmentWiringCableFunction",
                                                                          items:
                                                                            _vm
                                                                              .adminDataFieldsSrv
                                                                              .equipmentFieldOptions[
                                                                              _vm
                                                                                .equipmentFieldsList
                                                                                .equipmentWiringCableFunction
                                                                            ],
                                                                          value:
                                                                            entry.cableFunction,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            "Core Function",
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableFunction",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#fdf7e7",
                                                                          },
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CableManufacturer.Label"
                                                                            ),
                                                                          value:
                                                                            entry.cableManufacturer,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "cableManufacturer",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "6",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-text-field",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            color:
                                                                              "#fdf7e7",
                                                                          },
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.CableEntryType.Label"
                                                                            ),
                                                                          value:
                                                                            entry.coreInformation,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "coreInformation",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                    on: {
                                                                      dragover:
                                                                        _vm.allowDrop,
                                                                      drop: _vm.drop,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "h3",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "margin-bottom":
                                                                              "10px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "SiteComponents.EquipmentDetails.ConnectWith"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          items:
                                                                            _vm.getEquipmentsList,
                                                                          value:
                                                                            entry.connectWith,
                                                                          "item-text":
                                                                            "title",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.SelectEquipDP.Label"
                                                                            ),
                                                                          "return-object": false,
                                                                          multiple: false,
                                                                          clearable:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "connectWith",
                                                                                $event
                                                                              )
                                                                            },
                                                                          change:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.makeConnectWithFields(
                                                                                entry,
                                                                                index
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          loading:
                                                                            _vm.loadingConnectLists,
                                                                          items:
                                                                            _vm
                                                                              .finalList[
                                                                              index
                                                                            ],
                                                                          value:
                                                                            entry.connectWithMid,
                                                                          "item-text":
                                                                            "title",
                                                                          "item-value":
                                                                            "id",
                                                                          clearable:
                                                                            "",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.SelectOutputEntries.Label"
                                                                            ),
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "connectWithMid",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    attrs: {
                                                                      cols: "12",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "base-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.readOnlyFlagValue,
                                                                          dense:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          items:
                                                                            [
                                                                              "IN",
                                                                              "OUT",
                                                                              "N/A",
                                                                            ],
                                                                          value:
                                                                            entry.connectDirection,
                                                                          "item-text":
                                                                            "value",
                                                                          "item-value":
                                                                            "id",
                                                                          label:
                                                                            _vm.$t(
                                                                              "Fields.EquipmentFields.Direction.Label"
                                                                            ),
                                                                          clearable:
                                                                            "",
                                                                          "return-object": false,
                                                                        },
                                                                        on: {
                                                                          "update:value":
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.$set(
                                                                                entry,
                                                                                "connectDirection",
                                                                                $event
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "30px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "24px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.Documents"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                !_vm.addDocument
                                                                  ? _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "white--text",
                                                                        attrs: {
                                                                          color:
                                                                            "admin-primary ",
                                                                          icon: "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.addDocument = true
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {},
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-plus-circle-outline"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _vm.addDocument
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mb-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-row",
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "base-autocomplete",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    disabled:
                                                                                      _vm.readOnlyFlagValue,
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    clearable:
                                                                                      "",
                                                                                    rules:
                                                                                      "required",
                                                                                    items:
                                                                                      _vm.documentTypes,
                                                                                    value:
                                                                                      _vm.selectedType,
                                                                                    label:
                                                                                      _vm.$t(
                                                                                        "Fields.EquipmentFields.DocumentType.Label"
                                                                                      ),
                                                                                    "return-object": false,
                                                                                  },
                                                                                on: {
                                                                                  "update:value":
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.selectedType =
                                                                                        $event
                                                                                    },
                                                                                },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-file-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    dense:
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    disabled:
                                                                                      _vm.readOnlyFlagValue,
                                                                                    placeholder:
                                                                                      "Upload your documents",
                                                                                    label:
                                                                                      "File input",
                                                                                    "prepend-icon":
                                                                                      "mdi-paperclip",
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    _vm.filesSelected,
                                                                                },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "selection",
                                                                                        fn: function ({
                                                                                          text,
                                                                                        }) {
                                                                                          return [
                                                                                            _c(
                                                                                              "v-chip",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    small:
                                                                                                      "",
                                                                                                    label:
                                                                                                      "",
                                                                                                    color:
                                                                                                      "primary",
                                                                                                  },
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " " +
                                                                                                    _vm._s(
                                                                                                      text
                                                                                                    ) +
                                                                                                    " "
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "d-flex justify-end",
                                                                            attrs:
                                                                              {
                                                                                cols: "4",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "white--text mr-1",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "admin-primary ",
                                                                                    disabled:
                                                                                      !_vm.selectedType ||
                                                                                      !_vm.file,
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.upload(
                                                                                        entry.id ||
                                                                                          ""
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Save "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "white--text",
                                                                                attrs:
                                                                                  {
                                                                                    outlined:
                                                                                      "",
                                                                                    color:
                                                                                      "admin-primary",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    _vm.reset,
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Cancel "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-divider"
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _vm._l(
                                                              _vm.documents.filter(
                                                                (docs) =>
                                                                  docs.equipmentWiringCableId ===
                                                                  entry.id
                                                              ),
                                                              function (
                                                                document
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: `${document.id}`,
                                                                    staticStyle:
                                                                      {
                                                                        "margin-top":
                                                                          "10px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        "Documents - " +
                                                                          _vm._s(
                                                                            document.documentType
                                                                          ) +
                                                                          " - "
                                                                      ),
                                                                    ]),
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          document.title
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "base-btn",
                                                                      {
                                                                        staticClass:
                                                                          "mr-1",
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          icon: "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.view(
                                                                                document
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "admin-primary--text cursor-pointer",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-eye"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        staticClass:
                                                                          "mr-1",
                                                                        attrs: {
                                                                          icon: "",
                                                                          small:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.downloadDoc(
                                                                                document
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "admin-primary--text cursor-pointer",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-download"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    !_vm.readOnlyFlagValue
                                                                      ? _c(
                                                                          "base-btn",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.deleteDoc(
                                                                                    document
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-icon",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "red lighten-1",
                                                                                    size: "16px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "mdi-delete-empty"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        !_vm.readOnlyFlagValue
                                                          ? _c(
                                                              "v-card-actions",
                                                              [
                                                                _c("v-spacer"),
                                                                _c(
                                                                  "base-btn",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "background-color":
                                                                          "#fff !important",
                                                                        color:
                                                                          "#1b3054",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteCable(
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.Delete"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "base-btn",
                                                                  {
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateCable(
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Common.Update"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.showAddNew
                                        ? _c(
                                            "v-sheet",
                                            {
                                              staticStyle: {
                                                "margin-top": "20px",
                                              },
                                              attrs: { elevation: "0" },
                                            },
                                            [
                                              _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    "item-text":
                                                                      "sequence",
                                                                    "item-value":
                                                                      "sequence",
                                                                    items:
                                                                      _vm
                                                                        .siteLocationsSrv
                                                                        .selectedLcoation
                                                                        .wiringCables,
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    small: "",
                                                                    clearable:
                                                                      "",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.AddBeforeWire.Label"
                                                                      ),
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "item",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-list-item-content",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-item-title",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          `Wire ${
                                                                                            item.sequence ??
                                                                                            1
                                                                                          }`
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                        {
                                                                          key: "selection",
                                                                          fn: function ({
                                                                            item,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-chip",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      small:
                                                                                        "",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " Wire " +
                                                                                      _vm._s(
                                                                                        item.sequence ??
                                                                                          1
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      false,
                                                                      3939495591
                                                                    ),
                                                                  model: {
                                                                    value:
                                                                      _vm.newSeq,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.newSeq =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "newSeq",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .name,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.CableName.Label"
                                                                      ),
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "name",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.Manufacturer.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .manufacturer,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "manufacturer",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.ModelNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .modelNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "modelNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.SerialNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .serialNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "serialNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.CertificationNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .certificationNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "certificationNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    name: "wiringProtectionTypeAdd",
                                                                    items:
                                                                      _vm
                                                                        .adminDataFieldsSrv
                                                                        .equipmentFieldOptions[
                                                                        _vm
                                                                          .equipmentFieldsList
                                                                          .equipmentWiringCableProtectionType
                                                                      ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .protectionType,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.ProtectionType.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "protectionType",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.CableModelNo.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .cableModelNo,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "cableModelNo",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    name: "equipmentWiringCableFunctionAdd",
                                                                    items:
                                                                      _vm
                                                                        .adminDataFieldsSrv
                                                                        .equipmentFieldOptions[
                                                                        _vm
                                                                          .equipmentFieldsList
                                                                          .equipmentWiringCableFunction
                                                                      ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .cableFunction,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.CableFunction.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "cableFunction",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-text-field",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#fdf7e7",
                                                                  },
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.CableManufacturer.Label"
                                                                      ),
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .cableManufacturer,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "cableManufacturer",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "flex-grow-1",
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    name: "wiringCableEntryTypeAdd",
                                                                    items:
                                                                      _vm
                                                                        .adminDataFieldsSrv
                                                                        .equipmentFieldOptions[
                                                                        _vm
                                                                          .equipmentFieldsList
                                                                          .equipmentWiringCableEntryType
                                                                      ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .coreInformation,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.CableEntryType.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "coreInformation",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                              on: {
                                                                dragover:
                                                                  _vm.allowDrop,
                                                                drop: _vm.dropNew,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "h3",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-bottom":
                                                                      "10px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Connect With"
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    items:
                                                                      _vm.getEquipmentsList,
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .connectWith,
                                                                    "item-text":
                                                                      "title",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.SelectEquipDP.Label"
                                                                      ),
                                                                    "return-object": false,
                                                                    multiple: false,
                                                                    clearable:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "connectWith",
                                                                          $event
                                                                        )
                                                                      },
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.makeConnectWithFieldsNew(
                                                                          _vm
                                                                            .newWiringCableObj1
                                                                            .connectWith
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    loading:
                                                                      _vm.loadingConnectLists,
                                                                    items:
                                                                      _vm.finalListNew,
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .connectWithMid,
                                                                    "item-text":
                                                                      "title",
                                                                    "item-value":
                                                                      "id",
                                                                    clearable:
                                                                      "",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.SelectOutputEntries.Label"
                                                                      ),
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "connectWithMid",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "base-autocomplete",
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.readOnlyFlagValue,
                                                                    dense: "",
                                                                    outlined:
                                                                      "",
                                                                    items: [
                                                                      "IN",
                                                                      "OUT",
                                                                      "N/A",
                                                                    ],
                                                                    value:
                                                                      _vm
                                                                        .newWiringCableObj1
                                                                        .connectDirection,
                                                                    "item-text":
                                                                      "value",
                                                                    "item-value":
                                                                      "id",
                                                                    label:
                                                                      _vm.$t(
                                                                        "Fields.EquipmentFields.Direction.Label"
                                                                      ),
                                                                    clearable:
                                                                      "",
                                                                    "return-object": false,
                                                                  },
                                                                  on: {
                                                                    "update:value":
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$set(
                                                                          _vm.newWiringCableObj1,
                                                                          "connectDirection",
                                                                          $event
                                                                        )
                                                                      },
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  !_vm.readOnlyFlagValue
                                                    ? _c(
                                                        "v-card-actions",
                                                        [
                                                          _c("v-spacer"),
                                                          _c(
                                                            "base-btn",
                                                            {
                                                              on: {
                                                                click:
                                                                  _vm.saveNewCable,
                                                              },
                                                            },
                                                            [_vm._v("Save")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("PreviewDocumentDialogComponent", {
                                ref: "previewDialog",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c("InspectionHistoryComponent", {
                                attrs: {
                                  equipmentId:
                                    _vm.siteLocationsSrv.selectedLcoation.id,
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c(
                                                "v-card-title",
                                                { staticClass: "pt-0" },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticClass:
                                                        "text-h5 my-2",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "SiteComponents.EquipmentDetails.EquipmentDocuments"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-spacer"),
                                                  _c(
                                                    "span",
                                                    { staticClass: "ml-auto" },
                                                    [
                                                      !_vm.addDocument1
                                                        ? _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "white--text",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.readOnlyFlagValue,
                                                                color:
                                                                  "admin-primary ",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.addDocument1 = true
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Common.AddDocument"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-plus-circle-outline"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-card-text", [
                                            _vm.addDocument1
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mb-2" },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "base-autocomplete",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.readOnlyFlagValue,
                                                                  dense: "",
                                                                  outlined: "",
                                                                  clearable: "",
                                                                  rules:
                                                                    "required",
                                                                  items:
                                                                    _vm.documentTypes,
                                                                  value:
                                                                    _vm.selectedType,
                                                                  label:
                                                                    "Document Type",
                                                                  "return-object": false,
                                                                },
                                                                on: {
                                                                  "update:value":
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.selectedType =
                                                                        $event
                                                                    },
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c("v-file-input", {
                                                              attrs: {
                                                                dense: "",
                                                                outlined: "",
                                                                disabled:
                                                                  _vm.readOnlyFlagValue,
                                                                placeholder:
                                                                  "Upload your documents",
                                                                label:
                                                                  "File input",
                                                                "prepend-icon":
                                                                  "mdi-paperclip",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.filesSelected,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "selection",
                                                                      fn: function ({
                                                                        text,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-chip",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                  label:
                                                                                    "",
                                                                                  color:
                                                                                    "primary",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  false,
                                                                  1464597600
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "d-flex justify-end",
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "white--text mr-1",
                                                                attrs: {
                                                                  color:
                                                                    "admin-primary ",
                                                                  disabled:
                                                                    !_vm.selectedType ||
                                                                    !_vm.file,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.uploadEquip()
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v(" Save ")]
                                                            ),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "white--text",
                                                                attrs: {
                                                                  outlined: "",
                                                                  color:
                                                                    "admin-primary",
                                                                },
                                                                on: {
                                                                  click:
                                                                    _vm.cancelAddDocument,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " Cancel "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-divider"),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c("div", [
                                              _c(
                                                "table",
                                                { staticClass: "foex-table" },
                                                [
                                                  _c("thead", [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v("Type"),
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("File"),
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("Actions"),
                                                      ]),
                                                    ]),
                                                  ]),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.documents.filter(
                                                        (docs) =>
                                                          docs.equipmentWiringCableId ===
                                                          _vm.siteLocationsSrv
                                                            .selectedLcoation
                                                            ?.id
                                                      ),
                                                      function (document) {
                                                        return _c(
                                                          "tr",
                                                          {
                                                            key: `${document.id}`,
                                                          },
                                                          [
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  document.documentType
                                                                )
                                                              ),
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  document.title
                                                                )
                                                              ),
                                                            ]),
                                                            _c(
                                                              "td",
                                                              [
                                                                _c(
                                                                  "base-btn",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      small: "",
                                                                      icon: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.view(
                                                                            document
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "admin-primary--text cursor-pointer",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-eye"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    staticClass:
                                                                      "mr-1",
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadDoc(
                                                                            document
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "admin-primary--text cursor-pointer",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-download"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                      disabled:
                                                                        _vm.readOnlyFlagValue,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteDoc(
                                                                            document
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "red lighten-1",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-delete-empty"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("v-divider", {
                                        staticClass: "purple-divider",
                                        staticStyle: {
                                          "margin-top": "30px",
                                          "margin-bottom": "12px",
                                        },
                                      }),
                                      _c("v-divider", {
                                        staticClass: "mb-10 purple-divider",
                                        staticStyle: {
                                          "border-width": "1px !important",
                                        },
                                      }),
                                      _c("T3DModelDocumentsComponent", {
                                        attrs: {
                                          locationId:
                                            _vm.siteLocationsSrv
                                              .selectedLcoation.id,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("PreviewDocumentDialogComponent", {
                                ref: "previewDialog",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-textarea", {
                                                attrs: {
                                                  disabled:
                                                    _vm.readOnlyFlagValue,
                                                  outlined: "",
                                                  rows: "5",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.Note.Label"
                                                  ),
                                                  "auto-grow": "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.siteLocationsSrv
                                                      .selectedLcoation
                                                      .equipmentDetail.note,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.siteLocationsSrv
                                                        .selectedLcoation
                                                        .equipmentDetail,
                                                      "note",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "siteLocationsSrv.selectedLcoation.equipmentDetail.note",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("equipment-report-component", {
                                                attrs: {
                                                  siteId:
                                                    _vm.siteLocationsSrv
                                                      .selectedLcoation.siteId,
                                                  equipmentId:
                                                    _vm.siteLocationsSrv
                                                      .selectedLcoation.id,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _c("AreaRulesSummaryDialogComponent", {
            ref: "areaRulesSummaryDialogRef",
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }